import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-tinyminds-yellow via-tinyminds-lightPurple to-tinyminds-coral flex items-center justify-center p-4">
      <div className="text-center max-w-sm w-full mx-auto">
        <div className="flex justify-center mb-6">
          <div className="animate-spin rounded-full h-16 w-16 sm:h-20 sm:w-20 border-4 border-tinyminds-purple border-t-transparent"></div>
        </div>
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 sm:p-6 shadow-2xl">
          <p className="text-lg sm:text-xl font-fredoka font-bold text-tinyminds-purple animate-bounce leading-relaxed">
            🌈 Loading Amazing World Content... ✨
          </p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(LoadingSpinner);